import { ArrayType, NumberType, ObjectType, StringType } from '@hb/map-convert';
import { convertPoint, convertPointString } from '../../utils/transform';
/**
 * 入参转换
 */
export var queryType = {
    origin: StringType(convertPointString),
    destination: StringType(convertPointString),
};
var stepType = {
    instruction: StringType(),
    road: StringType(),
    orientation: StringType(),
    distance: NumberType(),
    duration: NumberType(),
    polyline: StringType(),
    action: StringType(),
    assistant_action: StringType('assistantAction'),
    walk_type: StringType('walkType'),
};
var pathType = {
    distance: NumberType(),
    duration: NumberType(),
    steps: ArrayType(ObjectType(stepType)),
};
/**
 * 返回值转换
 */
export var dataType = {
    origin: StringType('originLoc', convertPoint),
    destination: StringType('destLoc', convertPoint),
    paths: ArrayType(ObjectType(pathType)),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2FtYXAvd2Fsa2luZ1JvdXRlQnlTZXJ2ZXIvY29udmVydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLFVBQVUsRUFBRSxVQUFVLEVBQUUsVUFBVSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFHaEYsT0FBTyxFQUFFLFlBQVksRUFBRSxrQkFBa0IsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRXpFOztHQUVHO0FBQ0gsTUFBTSxDQUFDLElBQU0sU0FBUyxHQUFnQjtJQUNwQyxNQUFNLEVBQUUsVUFBVSxDQUFDLGtCQUFrQixDQUFDO0lBQ3RDLFdBQVcsRUFBRSxVQUFVLENBQUMsa0JBQWtCLENBQUM7Q0FDNUMsQ0FBQztBQUVGLElBQU0sUUFBUSxHQUFnQjtJQUM1QixXQUFXLEVBQUUsVUFBVSxFQUFFO0lBQ3pCLElBQUksRUFBRSxVQUFVLEVBQUU7SUFDbEIsV0FBVyxFQUFFLFVBQVUsRUFBRTtJQUN6QixRQUFRLEVBQUUsVUFBVSxFQUFFO0lBQ3RCLFFBQVEsRUFBRSxVQUFVLEVBQUU7SUFDdEIsUUFBUSxFQUFFLFVBQVUsRUFBRTtJQUN0QixNQUFNLEVBQUUsVUFBVSxFQUFFO0lBQ3BCLGdCQUFnQixFQUFFLFVBQVUsQ0FBQyxpQkFBaUIsQ0FBQztJQUMvQyxTQUFTLEVBQUUsVUFBVSxDQUFDLFVBQVUsQ0FBQztDQUNsQyxDQUFDO0FBRUYsSUFBTSxRQUFRLEdBQWdCO0lBQzVCLFFBQVEsRUFBRSxVQUFVLEVBQUU7SUFDdEIsUUFBUSxFQUFFLFVBQVUsRUFBRTtJQUN0QixLQUFLLEVBQUUsU0FBUyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQztDQUN2QyxDQUFDO0FBRUY7O0dBRUc7QUFDSCxNQUFNLENBQUMsSUFBTSxRQUFRLEdBQWdCO0lBQ25DLE1BQU0sRUFBRSxVQUFVLENBQUMsV0FBVyxFQUFFLFlBQVksQ0FBQztJQUM3QyxXQUFXLEVBQUUsVUFBVSxDQUFDLFNBQVMsRUFBRSxZQUFZLENBQUM7SUFDaEQsS0FBSyxFQUFFLFNBQVMsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUM7Q0FDdkMsQ0FBQyJ9